import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

const PageNavComponent = function ({ currentPage, totalPage, onChangePage }) {
  const isBackDisabled = currentPage === 1;
  const isNextDisabled = currentPage === totalPage;
  const menuLeft = isBackDisabled
    ? cn('glyphicon glyphicon-menu-left', 'disabled')
    : 'glyphicon glyphicon-menu-left';
  const menuRight = isNextDisabled
    ? cn('glyphicon glyphicon-menu-right', 'disabled')
    : 'glyphicon glyphicon-menu-right';

  const nextPageHandler = () => {
    if (isNextDisabled) { return; }
    onChangePage(currentPage + 1);
  };
  const prevPageHandler = () => {
    if (isBackDisabled) { return; }
    onChangePage(currentPage - 1);
  };
  return (
    <>
      <span className={menuLeft} onClick={prevPageHandler} aria-hidden="true" />
      <span className={menuRight} onClick={nextPageHandler} aria-hidden="true" />
    </>
  );
};

PageNavComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

export default PageNavComponent;
